// toast.tsx
import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultToastOptions: ToastOptions = {
  position: "top-right" as const,
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  closeButton: true,
  theme: "light" as const,
};

export const showSuccessToast = (message: string, options: ToastOptions = {}) => {
  toast.success(message, {
    ...defaultToastOptions,
    ...options,
  });
};

export const showErrorToast = (message: string, options: ToastOptions = {}) => {
  toast.error(message, {
    ...defaultToastOptions,
    ...options,
  });
};

export const ToastProvider = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};